import { render } from "./paymentBond.vue?vue&type=template&id=185bf6e8"
import script from "./paymentBond.vue?vue&type=script&lang=js"
export * from "./paymentBond.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__